<div class="tab-body">
<app-add-on-form
  label="Do you require an extended warranty for this item?"
  (formData)="getFormData($event)"
  name="ExtendedWarranty"
  [data]="ExtendedWarranty"
  [isReadOnly]="isReadOnly"
  [priceQuantity]="priceQuantity"
></app-add-on-form>

<app-add-on-form
  label="Do you require maintenance for this item?"
  (formData)="getFormData($event)"
  name="Maintenance"
  [data]="Maintenance"
  [isReadOnly]="isReadOnly"
  [priceQuantity]="priceQuantity"
></app-add-on-form>

<app-add-on-form
  label="Do you require an option-to-purchase for this item?"
  (formData)="getFormData($event)"
  name="OptionToPurchase"
  [data]="OptionToPurchase"
  [isReadOnly]="isReadOnly"
></app-add-on-form>
</div>
